/**
 * Split on the last occurrence of a space, e.g.
 * CS 24 -> "CS", "24"
 * BL ST 5 -> "BL ST", "5"
 * Special rule for ED, splits on first occurrence of a space, e.g.
 * ED HSS320W -> "ED", "HSS320W"
 * ED ST 392 -> "ED", "ST 392"
 */
export const getCourseDepartmentAndNumber = (course) => {
    let i = course.lastIndexOf(' ');
    if (course.startsWith("ED ")) i = 2;
    let department = course.substring(0, i).trim();
    let number = course.substring(i+1);

    return [department, number];
}

export const getCourseDepartment = (course, ignoreW = true) => {
    if (!ignoreW) return getCourseDepartmentAndNumber(course)[0];
    let i = course.lastIndexOf('W ');
    if (i === -1) i = course.lastIndexOf(' ');
    if (course.startsWith("ED ")) i = 2;
    let department = course.substring(0, i).trim();

    return department;
}
